module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-lighting.svg?c526efda7aaae43ff846728d3018662c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-lighting.svg
// module id = 1037
// module chunks = 1